<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="recycledAddEditForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                recycledAddEditForm.get('material')?.value ||
                recycledAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Material</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #material
              [items]="recycleList"
              [searchable]="false"
              bindLabel="description"
              formControlName="material"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder="Material *"
              [virtualScroll]="true"
              groupBy="childItems"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="accordion-search form-control search-input"
                    id="inputValidation"
                    (input)="material.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.description }}
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.description }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (recycledAddEditForm.controls['material']?.touched || submitted) &&
                recycledAddEditForm.controls['material']?.invalid
              "
              class="input-error"
            >
              Material is required.
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                recycledAddEditForm.get('material')?.value ||
                recycledAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationList"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="orgInputSearch"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="organization.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="recycledForm">
      <div class="row">
        <div class="col-sm-4 input-div" *ngFor="let formData of regionItems">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                [formControlName]="formData.regionName"
                type="number"
                maxlength="30"
                class="form-control input-custom-style"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="{{ formData.regionName }}"
              />
              <label>{{ formData.regionName }}</label>
              <div *ngIf="submitted && recycledForm.get(formData.regionName)?.invalid">
                <div class="input-error">Default value is required</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row">
                <div class="col-sm-4" *ngFor="let formData of regionItems;">
                    <div class="form-group required" aria-required="true">
                        <label>{{formData.regionName}}</label>
                        <input [formControlName]="formData.regionName" type="number" maxlength="30" class="form-control input-custom-style" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                        <div *ngIf="submitted && recycledForm.get(formData.regionName)?.invalid">
                            <div class="input-error">
                                Default value is required
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
    </form>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
